<template>
  <layout>
    <template slot="header">Change password</template>
    <validation-observer ref="form">
      <v-form
        autocomplete="off"
        style="height: 100%; overflow: auto"
        v-model="valid"
        lazy-validation
      >
        <validation-provider
          v-slot="{ errors }"
          :debounce="500"
          name="password"
          vid="password"
          rules="required|checkPassword"
        >
          <v-text-field
            label="New password"
            v-model="newPassword"
            autocomplete="off"
            :error-messages="errors"
            :append-icon="newPasswordType ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="() => (newPasswordType = !newPasswordType)"
            :type="newPasswordType ? 'password' : 'text'"
            clearable
            class="px-4"
          ></v-text-field>
        </validation-provider>
        <validation-provider
          v-slot="{ errors }"
          vid="repeatPassword"
          name="Repeat password"
          rules="required|confirmed:password"
        >
          <v-text-field
            autocomplete="new-password"
            v-model="newPasswordRepeat"
            :error-messages="errors"
            :append-icon="newPasswordRepeatType ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="
              () => (newPasswordRepeatType = !newPasswordRepeatType)
            "
            :type="newPasswordRepeatType ? 'password' : 'text'"
            label="Repeat password"
            clearable
            class="px-4 mb-2"
          ></v-text-field>
        </validation-provider>
      </v-form>
    </validation-observer>
    <template slot="footer">
      <v-spacer></v-spacer>
      <v-btn text @click="$emit('close')">Cancel</v-btn>
      <v-btn color="primary" text @click="saveHandler" :loading="loading"
        >save</v-btn
      >
    </template>
  </layout>
</template>

<script>
import Layout from '@/layouts/LayoutPopup';
import { reactive, ref, toRefs } from '@vue/composition-api';
import useUsers from '@/api/users';
import { useApolloClient } from '@vue/apollo-composable';
import userSchema from '@/api/users/item.graphql';
import { confirmed, required } from 'vee-validate/dist/rules';
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';

extend('required', {
  ...required,
  message: 'This field is required'
});

extend('confirmed', {
  ...confirmed,
  message: 'Passwords must be the same'
});

export default {
  name: 'EditPassword',
  components: { Layout, ValidationProvider, ValidationObserver },
  props: {
    userId: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit, root }) {
    const { user } = useUsers();
    const { resolveClient } = useApolloClient();
    const client = resolveClient();
    const form = ref(null);

    extend('checkPassword', {
      validate: async value => {
        const { data } = await client.query({
          query: userSchema.validatePasswordChange,
          variables: {
            userId: props.userId,
            newPassword: value
          }
        });

        const response = JSON.parse(data.validatePasswordChange);

        if (response.valid) {
          return true;
        }

        return response.comment;
      }
    });

    let state = reactive({
      valid: false,
      errors: {
        newPassword: '',
        newPasswordRepeat: ''
      },
      newPassword: '',
      newPasswordType: true,
      newPasswordRepeat: '',
      newPasswordRepeatType: true
    });

    const saveHandler = async () => {
      form.value.validate().then(success => {
        if (!success) {
          return;
        }
        user
          .update(root.$route.params.id, {
            password: state.newPassword
          })
          .then(() => {
            form.reset();
          })
          .finally(() => {
            user.loading.value = false;
            emit('close');
          });
      });
    };

    return {
      ...toRefs(state),
      saveHandler,
      form
    };
  }
};
</script>
